import styled, { css } from 'styled-components';
import { Container } from '../../../gridSystem';
import { NavBarHeight } from '../../../../const';

export const FirstNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  width: 100%;
  padding: 2px;
`;
export const SecondNav = styled.div`
  height: 59px;
  width: unset;
  margin-left: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const ActionWrapper = styled(Container)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .logout {
    margin-left: 10px;
    cursor: pointer;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0;
  position: relative;
`;

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;

  > div > form {
    position: relative;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 600;
`;

export const MenuElement = styled.span`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  transition: ${(props) => props.theme.constants.transitionBase};

  &:hover {
    color: ${(props) => props.theme.mixin.rgba(props.theme.colors.white, 0.6)};
  }

  span {
    margin-right: 10px;
  }
`;

export const SidebarMenu = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})`
  background-color: ${(props) => props.theme.colors.themeColor};
  top: calc(100% + 10px);
  right: 281px;
  position: absolute;
  padding: 10px;
  width: 150px;
  display: none;
  transition: ${(props) => props.theme.constants.transitionBase};
  ${(props) =>
    props.isOpen &&
    css`
      right: 281px;
      display: block;
    `};

  ${MenuElement} {
    width: 100%;
    &:not(:last-child) {
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
  }
`;

export const ModalWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.black20};
  position: fixed;
  left: 0;
  width: var(--full-width);
  height: 100vh;
`;

const Modal = styled.div`
  position: absolute;
  right: -54px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.bgPrimary};
  color: ${(props) => props.theme.colors.textPrimary};
  box-shadow: 1px 1px 12px 0px rgba(50, 50, 50, 0.55);
  transition: ${(props) => props.theme.constants.transitionBase};
`;
export const ModalContainer = styled(Container)`
  position: absolute;
  top: 118px;
  left: 300px;

  &.notifications {
    top: 18px;
  }

  &.tutor {
    right: 0;
    left: unset;
    top: 118px;
    width: 460px;
  }
`;

export const UserMenuModal = styled(Modal)`
  width: fit-content;
  margin-left: auto;
  margin-right: -22px;
  min-width: 280px;
  margin-right: 150px;

  & .with-border {
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.textSecondary};
  }
`;

export const Notifications = styled(Modal)`
  min-width: 459px;
  width: fit-content;
  margin-left: auto;
`;

export const ModalIconWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 30px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.bgSecondary};
  }

  & span {
    margin-right: 20px;
  }
`;

export const IconMenu = styled.div`
  cursor: pointer;
`;

export const Status = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: ${(props) => props.theme.colors.link};

  @media ${(props) => props.theme.device.mobileL} {
    position: absolute;
    top: 76px;
    left: 16px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  background-color: ${(props) => props.theme.colors.bgPrimary};
  border-radius: 4px 4px 0px 0px;
  color: ${(props) => props.theme.colors.textPrimary};
  padding: 16px 20px;
`;

export const SeeAll = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.textPrimary};
  white-space: nowrap;
  padding: 15px 40px 15px 40px;
  transition: ${(props) => props.theme.constants.transitionBase};
  text-align: end;
  border-top: 1px solid ${(props) => props.theme.colors.gray};
  width: 100%;

  span {
    margin-left: 10px;
    transition: ${(props) => props.theme.constants.transitionBase};
  }
`;

export const IconWrapperPeople = styled.div`
  background-color: ${(props) => props.theme.colors.black};
  width: 70px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.doveGray};
  }
`;

export const NameContainer = styled.div`
  height: ${NavBarHeight}px;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-left: 6px;
  padding: 0 24px;
  background-color: ${(props) => props.theme.colors.bgSubHeader};
  cursor: pointer;
`;

export const NameWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  &:hover,
  &:focus-visible {
    .h3 {
      position: relative;
      &::after {
        content: '';
        display: block;
        height: 0.4px;
        width: 100%;
        position: absolute;
        bottom: 3px;
        left: 0;
        background-color: ${(props) => props.theme.colors.white};
      }
    }
  }
`;

export const FullName = styled.div``;

export const MobileIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: 75%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NoResultContainer = styled.div`
  margin-bottom: 20px;
`;

export const FaqContainer = styled.div`
  margin-left: 20px;
`;
export const IconsContainer = styled.div`
  display: flex;
  margin-right: 10px;
`;
export const IconContainer = styled.div``;
export const NotificationBadge = styled.span``;
export const IconSpan = styled.span`
  font-size: 20px;

  &.disactive {
    position: relative;
    &::after {
      content: '';
      width: 141%;
      height: 2px;
      border-radius: 2px;
      position: absolute;
      bottom: 8px;
      left: -4px;
      -ms-transform: rotate(45deg);
      transform: rotate(-45deg);
      background-color: ${(props) => props.theme.colors.textPrimary};
    }
  }
`;

export const IconWrapperLogout = styled.div`
  padding: 4px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TutorContainer = styled.div`
  position: relative;
`;

export const TutorWrapper = styled.button`
  margin-left: 16px;
  padding-left: 13px;
  border-left: 2px solid ${(props) => props.theme.colors.white};

  h3,
  button {
    color: ${(props) => props.theme.colors.white} !important;
  }

  svg {
    margin-left: 4px;
    stroke: ${(props) => props.theme.colors.white};
  }

  &:hover,
  &:focus-visible {
    .h3 {
      position: relative;
      &::after {
        content: '';
        display: block;
        height: 0.4px;
        width: 100%;
        position: absolute;
        bottom: 3px;
        left: 0;
        background-color: ${(props) => props.theme.colors.white};
      }
    }
  }
`;

export const TutorModal = styled(Modal)`
  min-width: 315px;
  width: fit-content;
  margin-left: auto;
  background-color: ${(props) => props.theme.colors.white};
  right: -24px;
  top: -76px;

  & > h3,
  & > button {
    min-height: 46px;
    width: 100%;
    min-width: max-content;
    padding: 12px;
    border-bottom: 1px solid #e3e3e3;
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.link}!important;

    &:hover {
      color: ${(props) => props.theme.colors.btnHover}!important;
    }
  }

  .link-cta {
    width: 100%;
    &.border {
      border-bottom: 1px solid #e3e3e3;
    }
    h3,
    button {
      min-height: 46px;
      width: 100%;
      min-width: max-content;
      padding: 12px;
      background: ${(props) => props.theme.colors.white};
      color: ${(props) => props.theme.colors.link}!important;

      &:hover {
        color: ${(props) => props.theme.colors.btnHover} !important;
      }
    }

    .b3 {
      padding: 4px 12px 12px;
      &:last-child {
        border-bottom: 1px solid #e3e3e3;
      }

      svg {
        margin-top: -5px;
        stroke: ${(props) => props.theme.colors.link};
      }
      &:hover svg {
        stroke: ${(props) => props.theme.colors.btnHover};
      }
    }
  }
`;

export const NavBarContainer = styled.header.attrs(() => ({
  className: 'header header-wrapper',
}))`
  position: sticky;
  top: 0;
  width: 100%;
  max-width: var(--full-width);
  color: ${(props) => props.theme.colors.white};
  z-index: ${(props) => props.theme.zIndex.navBar};
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.bgHeader};

  &.header-wrapper {
    width: 100%;
    margin: 0;
    z-index: ${(props) => props.theme.zIndex.headerWrapper};
    margin-left: auto;
  }
`;

export const LogoutWrapper = styled.button`
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 20px;
  cursor: pointer;

  svg {
    stroke: ${(props) => props.theme.colors.bgHeader};
  }

  &:hover,
  &:focus-visible {
    svg {
      stroke: ${(props) => props.theme.colors.btnHover};
    }
    .h3 {
      position: relative;
      &::after {
        content: '';
        display: block;
        height: 0.4px;
        width: 100%;
        position: absolute;
        bottom: 3px;
        left: 0;
        background-color: ${(props) => props.theme.colors.white};
      }
    }
  }
`;
